import { useRouter } from 'next/router'

import curriculumAnalytics from '~/analytics/curriculum/curriculumAnalytics'
import { GradeType } from '~/onboarding/utils/grade-color.utils'
import LoaderSkeletonSimple from '~/components/Loaders/LoaderSkeletonSimple'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'

import ROUTES from '~/shared/constants/routes.const'
import { getCurriculumCountryCodeWithGradePrefix } from '~/curriculum/hooks/useGetCurriculumCountryCode'
import useGetGradeOverviewPageRoute from '~/dashboard/hooks/useGetGradeOverviewPageRoute'

import { selectCurriculumChangeLoading, setPreviousPageActionCreator } from '../slice/curriculum.slice'

import Grade from './Grade'

export const GradeDesign = ({ grade }: { grade: GradeType }): React.ReactElement => {
  const router = useRouter()
  const fromOnboarding = router.asPath.includes(ROUTES.ONBOARDING)

  const curriculumChangeLoading = useAppSelector(selectCurriculumChangeLoading)
  const countryCodeWithGradePrefix = getCurriculumCountryCodeWithGradePrefix(grade.countryCode)
  const dispatch = useAppDispatch()
  const curriculumGradeOverviewUrl = useGetGradeOverviewPageRoute({ grade: grade.gradeLevel })
  const gradeOnClickUrl = fromOnboarding ? `${ROUTES.DASHBOARD}?highlight=mastery` : curriculumGradeOverviewUrl

  const onGradeClick = (): void => {
    curriculumAnalytics.logSelectGradeClick(grade.gradeLevel, {
      gradeLabel: grade.gradeLabel,
      fromOnboarding,
    })
    dispatch(setPreviousPageActionCreator(`${ROUTES.BOOTCAMP_SELECT_GRADE}/${countryCodeWithGradePrefix}`))
  }

  if (curriculumChangeLoading) {
    return <LoaderSkeletonSimple className="h-16 w-80 lg:w-72 xl:w-80 rounded-2.5 my-4" />
  }

  return (
    <div className="flex flex-col min-h-23">
      <div className="flex gap-2">
        <button
          className="md:hover:scale-105 duration-300 w-full rounded shadow-rounded-button bg-gradient-to-r from-orange-logo via-pink-logo to-blue-logo p-0.5"
          key={grade.gradeLevel}
          onClick={onGradeClick}
        >
          <Grade gradeNumber={grade.gradeLevel} gradeOnClickUrl={gradeOnClickUrl} text={grade.gradeLabel} />
        </button>
      </div>
    </div>
  )
}
